import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PROVINCIES } from "@/lib/jobOptions";

export function MonteurFilters({ filters, setFilters }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-4 mb-6 flex flex-wrap gap-3 items-end">
      <div className="w-44">
        <Label className="text-xs font-bold text-slate-700">Specialisatie</Label>
        <Select value={filters.specialisatie} onValueChange={(v) => setFilters({ ...filters, specialisatie: v })}>
          <SelectTrigger data-testid="filter-specialisatie" className="rounded-sm border-slate-300"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle</SelectItem>
            <SelectItem value="ramen">Ramen</SelectItem>
            <SelectItem value="deuren">Deuren</SelectItem>
            <SelectItem value="beide">Ramen & Deuren</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-44">
        <Label className="text-xs font-bold text-slate-700">Regio</Label>
        <Input data-testid="filter-regio" value={filters.regio} onChange={(e) => setFilters({ ...filters, regio: e.target.value })} className="rounded-sm border-slate-300" placeholder="bv. Utrecht" />
      </div>
      <div className="w-48">
        <Label className="text-xs font-bold text-slate-700">Provincie</Label>
        <Select value={filters.provincie} onValueChange={(v) => setFilters({ ...filters, provincie: v })}>
          <SelectTrigger data-testid="filter-provincie" className="rounded-sm border-slate-300">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle provincies</SelectItem>
            {PROVINCIES.map((g) => (
              <div key={g.groep}>
                <div className="px-2 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wide">{g.groep}</div>
                {g.opties.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
              </div>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="w-48">
        <Label className="text-xs font-bold text-slate-700">Werkstatuut</Label>
        <Select value={filters.werkstatuut} onValueChange={(v) => setFilters({ ...filters, werkstatuut: v })}>
          <SelectTrigger data-testid="filter-werkstatuut" className="rounded-sm border-slate-300"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle</SelectItem>
            <SelectItem value="zelfstandige">Zelfstandige</SelectItem>
            <SelectItem value="flexi">Flexi-job</SelectItem>
            <SelectItem value="loondienst">Loondienst</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-48">
        <Label className="text-xs font-bold text-slate-700">Vervoer</Label>
        <Select value={filters.vervoer} onValueChange={(v) => setFilters({ ...filters, vervoer: v })}>
          <SelectTrigger data-testid="filter-vervoer" className="rounded-sm border-slate-300"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle</SelectItem>
            <SelectItem value="eigen_bestelwagen">Eigen bestelwagen</SelectItem>
            <SelectItem value="eigen_vervoer_geen_bestelwagen">Eigen vervoer</SelectItem>
            <SelectItem value="geen_vervoer">Geen vervoer</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-36">
        <Label className="text-xs font-bold text-slate-700">Rijbewijs</Label>
        <Select value={filters.rijbewijs} onValueChange={(v) => setFilters({ ...filters, rijbewijs: v })}>
          <SelectTrigger data-testid="filter-rijbewijs" className="rounded-sm border-slate-300"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle</SelectItem>
            <SelectItem value="B">B</SelectItem>
            <SelectItem value="BE">BE</SelectItem>
            <SelectItem value="C">C</SelectItem>
            <SelectItem value="CE">CE</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-40">
        <Label className="text-xs font-bold text-slate-700">Taal</Label>
        <Select value={filters.taal} onValueChange={(v) => setFilters({ ...filters, taal: v })}>
          <SelectTrigger data-testid="filter-taal" className="rounded-sm border-slate-300"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="alle">Alle</SelectItem>
            <SelectItem value="Nederlands">Nederlands</SelectItem>
            <SelectItem value="Frans">Frans</SelectItem>
            <SelectItem value="Engels">Engels</SelectItem>
            <SelectItem value="Duits">Duits</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="w-44">
        <Label className="text-xs font-bold text-slate-700">Beschikbaar op</Label>
        <div className="flex items-center gap-1">
          <Input data-testid="filter-beschikbaar-op" type="date" value={filters.beschikbaar_op}
            onChange={(e) => setFilters({ ...filters, beschikbaar_op: e.target.value })}
            className="rounded-sm border-slate-300" />
          {filters.beschikbaar_op && (
            <button data-testid="clear-datum-btn" onClick={() => setFilters({ ...filters, beschikbaar_op: "" })}
              className="text-xs text-slate-400 hover:text-red-600 px-1" title="Wissen">✕</button>
          )}
        </div>
      </div>
      <label className="flex items-center gap-2 text-sm font-medium text-slate-700 cursor-pointer pb-2">
        Alleen beschikbaar
      </label>
      <label className="flex items-center gap-2 text-sm font-medium text-slate-700 cursor-pointer pb-2">
        <input data-testid="filter-leiding" type="checkbox" checked={filters.leiding_team} onChange={(e) => setFilters({ ...filters, leiding_team: e.target.checked })} className="accent-orange-500 w-4 h-4" />
        Leidinggevend
      </label>
      <label className="flex items-center gap-2 text-sm font-medium text-slate-700 cursor-pointer pb-2">
        <input data-testid="filter-materiaal" type="checkbox" checked={filters.eigen_materiaal} onChange={(e) => setFilters({ ...filters, eigen_materiaal: e.target.checked })} className="accent-orange-500 w-4 h-4" />
        Eigen werkmateriaal
      </label>
    </div>
  );
}
